<template>
  <div class="app-container goods-tag-page">
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="标签列表" name="tags" />
      <el-tab-pane label="标签联动" name="linkages" />
    </el-tabs>

    <div v-show="activeTab === 'tags'">
      <div class="filter-container">
        <el-input
          v-model="listQuery.name"
          placeholder="标签名称"
          style="width: 180px"
          class="filter-item"
          clearable
        />
        <el-select
          v-model="listQuery.status"
          placeholder="是否启用"
          style="width: 120px"
          class="filter-item"
          clearable
        >
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
        <el-select
          v-model="listQuery.type"
          placeholder="标签分类"
          style="width: 150px"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in TAGS_TYPE"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
          >搜索</el-button
        >
        <el-button class="filter-item" type="primary" icon="el-icon-plus" @click="openDialog()"
          >新增</el-button
        >
      </div>

      <el-table v-loading="listLoading" :data="list" size="small" border fit highlight-current-row>
        <el-table-column label="ID" prop="id" align="center" width="80" />
        <el-table-column label="标签图标" prop="icon" align="center" width="120">
          <template slot-scope="scope">
            <el-image v-if="scope.row.icon" class="tag-icon" :src="scope.row.icon" fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="标签名称" prop="name" align="center" />
        <el-table-column label="是否启用" prop="status" align="center" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分类标签" prop="type" align="center" width="140">
          <template slot-scope="scope">
            {{ getValue(TAGS_TYPE, scope.row.type) || "其他系统标签" }}
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort" align="center" width="100" />
        <el-table-column label="创建时间" prop="ctdate" align="center" width="180">
          <template slot-scope="scope">{{ formatApiDate(scope.row.ctdate) }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" plain @click="removeTag(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="listQuery.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <div v-show="activeTab === 'linkages'" class="linkage-panel">
      <el-alert
        title="配置触发标签后需要自动附加的标签。系统触发适用于秒杀、超级补贴等业务标签；手动触发适用于运营在商品编辑页选择的入口标签。"
        type="info"
        :closable="false"
        show-icon
      />
      <div class="linkage-toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openLinkageDialog()"
          >新增联动</el-button
        >
        <el-button icon="el-icon-refresh" :loading="syncing" @click="syncLinkages"
          >重算商品标签</el-button
        >
      </div>
      <el-table v-loading="linkageLoading" :data="linkages" size="small" border fit>
        <el-table-column label="触发标签" min-width="190">
          <template slot-scope="scope">
            <span>{{ formatTag(scope.row.sourceTagId) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="触发方式" width="130" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.triggerMode === 2 ? 'warning' : 'primary'">
              {{ scope.row.triggerMode === 2 ? "系统触发" : "手动选择" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="自动附加标签" min-width="360">
          <template slot-scope="scope">
            <el-tag
              v-for="tagId in scope.row.targetTagIds"
              :key="tagId"
              class="linkage-tag"
              type="success"
            >
              {{ formatTag(tagId) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openLinkageDialog(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" plain @click="removeLinkage(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="form.id ? '编辑标签' : '新增标签'"
      :visible.sync="dialogVisible"
      width="460px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="标签名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入标签名称" maxlength="30" />
        </el-form-item>
        <el-form-item label="标签图标">
          <div class="icon-uploader" @click="$refs.iconInput.click()">
            <img v-if="form.icon" :src="form.icon" alt="" />
            <i v-else class="el-icon-plus"></i>
          </div>
          <input
            ref="iconInput"
            class="hidden-input"
            type="file"
            accept="image/*"
            @change="handleIconUpload"
          />
        </el-form-item>
        <el-form-item label="分类标签" prop="type">
          <el-select
            v-model="form.type"
            placeholder="请选择分类标签"
            style="width: 120px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in TAGS_TYPE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveTag">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="linkageEditing ? '编辑标签联动' : '新增标签联动'"
      :visible.sync="linkageDialogVisible"
      width="560px"
      :close-on-click-modal="false"
    >
      <el-form ref="linkageForm" :model="linkageForm" :rules="linkageRules" label-width="110px">
        <el-form-item label="触发标签" prop="sourceTagId">
          <el-select
            v-model="linkageForm.sourceTagId"
            filterable
            placeholder="请选择触发标签"
            style="width: 100%"
            :disabled="linkageEditing"
          >
            <el-option
              v-for="tag in sourceTagOptions"
              :key="tag.id"
              :label="formatTag(tag.id)"
              :value="tag.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="触发方式" prop="triggerMode">
          <el-radio-group v-model="linkageForm.triggerMode">
            <el-radio :label="1">商品编辑时手动选择</el-radio>
            <el-radio :label="2">活动或业务条件系统触发</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动附加" prop="targetTagIds">
          <el-select
            v-model="linkageForm.targetTagIds"
            multiple
            filterable
            collapse-tags
            placeholder="请选择自动附加标签"
            style="width: 100%"
          >
            <el-option
              v-for="tag in targetTagOptions"
              :key="tag.id"
              :label="formatTag(tag.id)"
              :value="tag.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="linkageForm.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="linkageDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="linkageSaving" @click="saveLinkage">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteGoodsTag,
  deleteGoodsTagLinkage,
  editGoodsTag,
  editGoodsTagLinkage,
  getGoodsTagLinkageList,
  getGoodsTagList,
  syncGoodsTagLinkage
} from "@/api/product";
import { uploadImage } from "@/api/common";
import { formatApiDate } from "@/utils/utils";
import { TAGS_TYPE, getValue } from "@/utils/enumUtile";

export default {
  name: "GoodsTagManagement",
  data() {
    return {
      activeTab: "tags",
      list: [],
      total: 0,
      listLoading: false,
      dialogVisible: false,
      saving: false,
      allTags: [],
      linkages: [],
      linkageLoading: false,
      linkageDialogVisible: false,
      linkageSaving: false,
      linkageEditing: false,
      syncing: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        name: "",
        status: null,
        type: null
      },
      form: {
        id: null,
        name: "",
        icon: "",
        status: 1,
        sort: 0,
        type: null
      },
      rules: {
        name: [{ required: true, message: "标签名称不能为空", trigger: "blur" }],
        status: [{ required: true, message: "请选择是否启用", trigger: "change" }],
        type: [{ required: true, message: "请选择分类标签", trigger: "change" }]
      },
      linkageForm: {
        sourceTagId: null,
        targetTagIds: [],
        triggerMode: 1,
        status: 1
      },
      linkageRules: {
        sourceTagId: [{ required: true, message: "请选择触发标签", trigger: "change" }],
        targetTagIds: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "至少选择一个自动附加标签",
            trigger: "change"
          }
        ],
        triggerMode: [{ required: true, message: "请选择触发方式", trigger: "change" }]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getValue,
    formatApiDate,
    handleTabChange(tab) {
      if (tab.name === "linkages") {
        this.loadLinkageData();
      }
    },
    getList() {
      this.listLoading = true;
      getGoodsTagList(this.listQuery)
        .then(response => {
          const data = response.data || {};
          this.list = data.entitys || [];
          this.total = data.totalCount || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    openDialog(row) {
      this.form = row
        ? {
            id: row.id,
            name: row.name,
            icon: row.icon,
            status: row.status,
            sort: row.sort || 0,
            type: row.type || null
          }
        : {
            id: null,
            name: "",
            icon: "",
            status: 1,
            sort: 0,
            type: null
          };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleIconUpload(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;
      if (!file.type || !file.type.startsWith("image/")) {
        this.$message.warning("请选择图片文件");
        return;
      }
      uploadImage({ file, type: "COMMON" }).then(response => {
        const data = response.data || {};
        this.form.icon = data.accessUrl || data.dbUrl || data.url || "";
      });
    },
    saveTag() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.saving = true;
        editGoodsTag(this.form)
          .then(response => {
            if (response.bizcode === 100) {
              this.$message.success("保存成功");
              this.dialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    removeTag(row) {
      this.$confirm(`确认删除标签「${row.name}」？`, "提示", { type: "warning" }).then(() => {
        deleteGoodsTag({ id: row.id }).then(response => {
          if (response.bizcode === 100) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
    loadLinkageData() {
      this.linkageLoading = true;
      Promise.all([getGoodsTagList({ page: 1, pageSize: 1000 }), getGoodsTagLinkageList()])
        .then(([tagResponse, linkageResponse]) => {
          const tagData = tagResponse.data || {};
          this.allTags = tagData.entitys || [];
          this.linkages = linkageResponse.data || [];
        })
        .finally(() => {
          this.linkageLoading = false;
        });
    },
    formatTag(tagId) {
      const tag = this.allTags.find(item => String(item.id) === String(tagId));
      if (!tag) return `标签 #${tagId}`;
      const typeName = getValue(TAGS_TYPE, tag.type) || "其他系统标签";
      return `${typeName} / ${tag.name}`;
    },
    openLinkageDialog(row) {
      if (!this.allTags.length) {
        this.loadLinkageData();
      }
      this.linkageEditing = !!row;
      this.linkageForm = row
        ? {
            sourceTagId: row.sourceTagId,
            targetTagIds: (row.targetTagIds || []).slice(),
            triggerMode: row.triggerMode || 1,
            status: row.status === 0 ? 0 : 1
          }
        : { sourceTagId: null, targetTagIds: [], triggerMode: 1, status: 1 };
      this.linkageDialogVisible = true;
      this.$nextTick(() => this.$refs.linkageForm && this.$refs.linkageForm.clearValidate());
    },
    saveLinkage() {
      this.$refs.linkageForm.validate(valid => {
        if (!valid) return;
        this.linkageSaving = true;
        editGoodsTagLinkage({
          ...this.linkageForm,
          targetTagIds: this.linkageForm.targetTagIds.join(",")
        })
          .then(response => {
            if (response.bizcode === 100) {
              this.$message.success("标签联动保存成功，商品标签已同步重算");
              this.linkageDialogVisible = false;
              this.loadLinkageData();
            }
          })
          .finally(() => {
            this.linkageSaving = false;
          });
      });
    },
    removeLinkage(row) {
      this.$confirm(`确认删除「${this.formatTag(row.sourceTagId)}」的联动配置？`, "提示", {
        type: "warning"
      }).then(() => {
        deleteGoodsTagLinkage({ sourceTagId: row.sourceTagId }).then(response => {
          if (response.bizcode === 100) {
            this.$message.success("删除成功，关联商品标签已重算");
            this.loadLinkageData();
          }
        });
      });
    },
    syncLinkages() {
      this.$confirm("将按当前配置重算全部商品标签，是否继续？", "重算商品标签", {
        type: "warning"
      }).then(() => {
        this.syncing = true;
        syncGoodsTagLinkage()
          .then(response => {
            if (response.bizcode === 100) {
              this.$message.success(`重算完成，共更新 ${response.data || 0} 个商品`);
            }
          })
          .finally(() => {
            this.syncing = false;
          });
      });
    }
  },
  computed: {
    TAGS_TYPE() {
      return TAGS_TYPE;
    },
    sourceTagOptions() {
      const editingSource = this.linkageForm.sourceTagId;
      const configured = new Set(this.linkages.map(item => String(item.sourceTagId)));
      return this.allTags.filter(
        tag =>
          tag.status === 1 &&
          (!configured.has(String(tag.id)) || String(tag.id) === String(editingSource))
      );
    },
    targetTagOptions() {
      return this.allTags.filter(
        tag => tag.status === 1 && String(tag.id) !== String(this.linkageForm.sourceTagId)
      );
    }
  }
};
</script>

<style scoped lang="scss">
.goods-tag-page {
  .linkage-panel {
    .linkage-toolbar {
      margin: 18px 0;
    }

    .linkage-tag {
      margin: 3px 6px 3px 0;
    }
  }

  .tag-icon {
    width: 44px;
    height: 44px;
    border-radius: 6px;
  }

  .icon-uploader {
    width: 86px;
    height: 86px;
    display: grid;
    place-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    i {
      color: #8c939d;
      font-size: 26px;
    }
  }

  .hidden-input {
    display: none;
  }
}
</style>
